export const EducationItems = [
    {
        educationName: 'Computer Science Specialist',
        schoolName: 'University of Toronto',
        time: 'Sept 2019 - Present',
        isExpanded: true,
        descriptionItems: [
            {
                title: 'U of T Dean\'s Scholar (cGPA: 3.72)',
                sublist: [],
            },
            {
                title: 'UofT Scholars Award (monetary value: $7,500)',
                sublist: [],
            },
            {
                title: 'Past Courses:',
                sublist: [
                    'Computational Linguistics (CSC485)',
                    'Formal Methods in Software Design (CSC465)',
                    'Business of Software (CSC454)',
                    'Computer Networks (CSC458)',
                    'Algorithm Design and Ananlysis (CSC373)',
                    'Operating Systems (CSC369)',
                    'Introduction to Database Systems (CSC343)',
                    'Interactive Computational Media (CSC318)',
                    'Programming on the Web (CSC309)',
                    'Introduction to Software Engineering (CSC301)',
                    'Probability and Statistics with Computer Applications (STA247)',
                    'Data Structures and Analysis (CSC263)',
                    'Computer Organization(CSC258)',
                    'Theory of Computation (CSC236)',
                    'Software Tools and Systems Programming (CSC209)',
                    'Software Design (CSC207)',
                    'Multivariable Calculus (MAT235)',
                    'Statistical Reasoning (STA130)',
                    'Mathematical Expressioning and Reasoning for Computer Science (CSC165)',
                    'Introduction to Computer Science (CSC148)',
                    'Intro to Computer Programming (CSC108)',
                    'Linear Algebra (MAT223)',
                ],
            },
        ],
    },
    {
        educationName: 'High School Diploma',
        schoolName: 'North Albion C.I.',
        time: 'September 2015 - June 2019',
        isExpanded: false,
        descriptionItems: [
            {
                title: 'Ontario Secondary School Diploma, 2019',
                sublist: [],
            },
            {
                title: 'Honor Roll, 2015-2019',
                sublist: [],
            },
            {
                title: '2nd General Proficiency Award',
                sublist: [],
            },
            {
                title: 'Some Courses:',
                sublist: [
                    'Computer Science (ICS4U1, ICS3U1, ICS201)',
                    'Physics (SPH4U1, SPH3U1)',
                    'Chemistry (SCH4U1, SCH3U1)',
                    'Computer Engineering (TEJ4U1, TEJ3U1)',
                    'Calculus (MCV4U1)',
                ],
            },
        ],
    },
]